import { reactive } from "vue";
import { GOOGLE_MAP_KEY } from "@/utils/config";
const useGoogleMapEffect = () => {
    const googleMapParam = reactive({
        load: {
            key: GOOGLE_MAP_KEY,
            language: 'en-US', //en-US  zh-CN
            region: 'CN', //CN    US
            v: 'weekly', // 指定使用最新的稳定版本
            // version: "3.49", // 指定稳定版本
        },
    })
    return { googleMapParam };
};
const { googleMapParam } = useGoogleMapEffect()
export { googleMapParam }